import { ListRange, SearchCriteriaBase } from '../../../../../common/models/list.model';
import { ListQueryParam } from '../../../../../common/constants/list-query-param.constant';
import { DatepickerRangeModel, DatepickerRangeOutput } from '../../../../../common/models/datepicker.model';
import { LocalDate } from '../../../../models';
import { MasterDataFileStatus, MasterDataType } from '../constants';

export enum MasterDataRangeDate {
  DateTimeRange = 'dateTimeRange',
}

export type MasterDataDateRangeFilter = MasterDataRangeDate;

export type MasterDataTimestampValues = {
  [key in MasterDataDateRangeFilter]: DatepickerRangeModel;
};
export type MasterDataDateValues = {
  [key in MasterDataDateRangeFilter]: DatepickerRangeOutput;
};

export class MasterDataBrief {
  id: number;
  fileId: string;
  fileName: string;
  createdBy: string;
  creationDate: LocalDate;
  errorMessage: string;
  type: MasterDataType;
  status: MasterDataFileStatus;

  constructor(params?: MasterDataBrief) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface MasterDataSearchOutput {
  timezone: string;
  filter: MasterDataListSearchCriteria;
}

export class MasterDataListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;
  [ListQueryParam.DateTimeRange]: DatepickerRangeOutput;
  [ListQueryParam.Status]: string[] = [];
  [ListQueryParam.Type]: MasterDataType[] = [];

  constructor(params?: MasterDataListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
